/* eslint-disable react-hooks/exhaustive-deps */

import {
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";
import {
  DatatablesFooterServerSide,
  InputOptionMaster,
  InputTextMaster,
  Loading,
  Title,
  MasterButton,
  TableHeader,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import {
  DEFAULT_SHOW_BUTTON_SEARCH,
  DISABLED_BUTTON_SUBMIT,
  STYLE_DEFAULT_MASTER,
} from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  isNull,
  defaultToastError,
  defaultDateDisplay,
} from "App/utils/helpers";
import { RefreshIcon } from "App/Assets";
import React, { useEffect, useState } from "react";
import { TableRootDepartemen } from "./TableRootDepartemen";
import { getByFilterBarang } from "../../../Wms/PerbekalanFarmasi/Master/MasterBarang/ui";
import {
  getTabItem,
  STYLE_DEPARTEMEN,
  RESET_STATE_FORM_FILTER,
  posisiSelect,
} from "./helpers";

function Departemen() {
  const [rows, setRows] = useState([]);
  const [formInput, setFormInput] = useState(RESET_FORM_INPUT);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SEARCH);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    await setNewData(formInput.pages, formInput.limit);
    setDisabled(DEFAULT_SHOW_BUTTON_SEARCH);
  };

  const setNewData = async (pages, limit) => {
    try {
      setLoading(true);
      const response = await getTabItem(formInput, pages, limit);
      if (response.state) {
        setRows(response.data);
        setTotalData(response.meta.count);
        setLoading(false);
      } else {
        setRows([]);
        setLoading(false);
        setTotalData(0);
        defaultToastError(response.message);
      }
    } catch (error) {
      setLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });
  const classes = STYLE_DEFAULT_MASTER();
  return (
    <Paper
      className={classes.paper}
      style={{
        padding: "1rem",
      }}>
      <Title title='Master Departemen' />
      <div>
        <FormDepartemen
          formInput={formInput}
          setFormInput={setFormInput}
          handleSubmit={handleSubmit}
          disabled={disabled}
        />

        <div className='mt-2'>
          <Loading show={loading} />
          <TableTabItem rows={rows} />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </div>
    </Paper>
  );
}

const TableTabItem = ({ rows }) => {
  const classes = STYLE_DEFAULT_MASTER();
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "penjualanId",
    orderByRow: ["penjualanId"],
  });

  return (
    <>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell align='left'>{row.penjualanId}</TableCell>
                    <TableCell align='left'>
                      {defaultDateDisplay(row.tanggal_penjualan, true)}
                    </TableCell>
                    <TableCell align='left'>{row.tagihan_id}</TableCell>
                    <TableCell align='left'>{row.barang_id}</TableCell>
                    <TableCell align='left'>{row.barang_name}</TableCell>
                    <TableCell align='left'>{row.type_of_care_name}</TableCell>
                    <TableCell align='left'>{row.jenis_layanan_name}</TableCell>
                    <TableCell align='left'>{row.gudang_name}</TableCell>
                    <TableCell align='left'>{row.harga_jual}</TableCell>
                    <TableCell align='left'>{row.qty}</TableCell>
                    <TableCell align='left'>{row.id_rm}</TableCell>
                    <TableCell align='left'>{row.nama_rm}</TableCell>
                    <TableCell align='left'>{row.produsen_name}</TableCell>
                    <TableCell align='left'>{row.insurance_name}</TableCell>
                  </TableRow>
                );
              }
            )}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const FormDepartemen = ({
  formInput,
  setFormInput,
  handleSubmit,
  disabled,
}) => {
  // const jenisLayanan = useSelectOption(
  //   true,
  //   "/jenis_layanan/listjenis_layanan",
  //   TYPE_INSTANCE2
  // );

  const handleChangeOption = (e, id, name) => {
    if (isNull(e)) {
      setFormInput({
        ...formInput,
        [id]: null,
        [name]: "Pilih",
      });
    } else {
      setFormInput({
        ...formInput,
        [id]: e.value,
        [name]: e.label,
      });
    }
  };

  const handleChange = (text) => (e) => {
    setFormInput({
      ...formInput,
      [text]: e.target.value,
    });
  };

  const handleClickSelect = (row) => {
    setFormInput({
      ...formInput,
      barang_id: row.id,
      barang_name: row.name,
    });
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={6}>
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <InputTextMaster
                  name='departemen_id'
                  label='ID DEPARTEMEN'
                  id='departemen_id'
                  value={formInput.departemen_id}
                  onChange={handleChange("departemen_id")}
                  placeholder='ID Departemen'
                  readOnly={true}
                />
              </Grid>
              <Grid item sm={12}>
                <InputTextMaster
                  name='kode'
                  label='KODE'
                  id='kode'
                  value={formInput.kode}
                  onChange={handleChange("kode")}
                  placeholder='Kode Departemen'
                />
              </Grid>
              <Grid item sm={12}>
                <InputTextMaster
                  name='info'
                  label='INFO'
                  id='info'
                  value={formInput.info}
                  onChange={handleChange("info")}
                  placeholder='Info'
                />
              </Grid>

              <Grid item sm={6}>
                <InputOptionMaster
                  name='posisi'
                  label='POSISI'
                  id='posisi'
                  withSearch={true}
                  data={posisiSelect}
                  value={formInput.posisi_id}
                  labelValue={formInput.posisi_name}
                  onChange={(e) =>
                    handleChangeOption(e, "posisi_id", "posisi_name")
                  }
                />
              </Grid>
              <Grid item sm={6}>
                <InputTextMaster
                  name='posisi_root'
                  label='Posisi Root'
                  id='posisi_root'
                  value={formInput.posisi_root}
                  onChange={handleChange("posisi_root")}
                  withButton={true}
                  placeholder='Posisi Root'
                  readOnly={true}>
                  <button
                    type={"button"}
                    onClick={() => handleChange}
                    style={{
                      borderRight: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderLeft: "0",
                      background: "#fff",
                      padding: "0 0.8rem",
                      cursor: "pointer",
                      borderRadius: "0 6px 6px 0",
                    }}>
                    <RefreshIcon width={"20"} height={"25"} fill={"#333"} />
                  </button>
                </InputTextMaster>
              </Grid>
              <InputTextMaster
                name='posisi_root_id'
                type='hidden'
                id='posisi_root'
                value={formInput.posisi_root_id}
                onChange={handleChange("posisi_root")}
                withButton={true}
                readOnly={true}></InputTextMaster>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'>
                <MasterButton
                  className={"mt-1"}
                  type='button'
                  color={"danger"}
                  outline={true}
                  name={"RESET"}
                  onClick={() => setFormInput(RESET_FORM_INPUT)}
                  size='md'
                />

                <div>
                  <MasterButton
                    className={"mt-1"}
                    type='submit'
                    color={disabled.color}
                    name={disabled.label}
                    size='md'
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={6}>
            <ListBarang handleClickSelect={handleClickSelect} />
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "action",
    disablePadding: false,
    label: "ACTION",
    align: "left",
    minWidth: "50px",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "50px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA DEPARTEMEN",
    align: "left",
    minWidth: "140px",
  },
];

const RESET_FORM_INPUT = {
  departemen_id: "",
  kode: "",
  info: "",
  posisi: "",

  posisi_id: null,
  posisi_name: "Pilih Posisi",

  posisi_root: "Root",
  posisi_root_id: 0,

  pages: 1,
  limit: 10,
};

const ListBarang = ({ handleClickSelect }) => {
  // const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const formFilter = RESET_STATE_FORM_FILTER;
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const classes = STYLE_DEPARTEMEN();

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterBarang(pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []);

  // const handleChange = (text) => (e) => {
  //   setFormInput({
  //     ...formInput,
  //     [text]: e.target.value,
  //   });
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   await setNewData();
  // };

  return (
    <>
      <div>
        <Paper className={classes.paper}>
          <div className='mt-1'>
            <Loading show={loading} />
            <TableRootDepartemen
              rows={rows}
              classes={classes}
              isSelect={true}
              maxHeight='300px'
              handleClickSelect={handleClickSelect}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  );
};

export default Departemen;
